import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../../actions/appDataActions';
import OptionFeeback from '../OptionFeedback';//eslint-disable-line import/no-named-as-default
import Button from '../../../buttons/Button';//eslint-disable-line import/no-named-as-default
import ScoreKpi from '../../kpi/ScoreKpi';//eslint-disable-line import/no-named-as-default
import BadgeCollect from '../../badges/BadgeCollect';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import Resources from '../../resourceLinks/ResourceLinks';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as userDataActions from '../../../../actions/userDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as kpiConstants from '../../../../constants/kpiConstants';
import * as localStorage from '../../../../localStorage/localStorage';
import * as appConstants from "../../../../constants/appConstants";
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import {TweenLite, Elastic, Bounce, Expo, Linear} from 'gsap';
import gsap from 'gsap-react-plugin';
import _ from 'lodash';


class MultipleAnswerFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            options: this.props.options,
            locale: appHelper.getLocalData(this.props.responseData.outcome),
            hideFeedback: this.props.hideFeedback,
            showFeedbackContent: false,
            showKpis: appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis.length > 0,
            showProgression: false,
            enableProgression: appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis.length === 0,
            optionFeedback: [],
            kpiDashboardParams: {
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: false,
            dialogComplete: true,
            hasBadges: appHelper.isDefined(this.props.responseData.outcome.badges) && this.props.responseData.outcome.badges.length > 0,
            badgesCollected: false,
            resourceLinks:[],
            hasResources: false,
            resourcesAreComplete: true,
            missedOptions:{
                show: false,
                options:[]
            },
            completionCalled: false,
            feedbackInterval: {},
            review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
            updateLocale: false,
        };
        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.handleOptionFeedback = this.handleOptionFeedback.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.getLinkClass = this.getLinkClass.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.onKeyMessageToolboxComplete = this.onKeyMessageToolboxComplete.bind(this);
        this.setKeyMessageToolboxCallbacks = this.setKeyMessageToolboxCallbacks.bind(this);
        this.checkAllKeyMessageToolboxesComplete = this.checkAllKeyMessageToolboxesComplete.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getMissedOptions = this.getMissedOptions.bind(this);
        this.checkIsReadyToComplete = this.checkIsReadyToComplete.bind(this);
        this.setComplete = this.setComplete.bind(this);
        this.showProgressButton = this.showProgressButton.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onReview = this.onReview.bind(this);
        this.setFeedbackInterval = this.setFeedbackInterval.bind(this);
        this.checkShowProgressButton = this.checkShowProgressButton.bind(this);
    }

    componentDidMount() {
        if(appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.props.responseData.outcome.character_pose)){
            this.props.callbacks.updateCharacterExpression(this.props.responseData.outcome.character_pose);
        }
        //this.setResources();
        this.getAssets();
        this.getMissedOptions();
        this.handleOptionFeedback();
        this.setFeedbackInterval();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.hideFeedback !== nextProps.hideFeedback) {
            this.setState({hideFeedback: nextProps.hideFeedback});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.responseData.outcome),
                review_other_options_label: appHelper.getLocaleString("review_other_options_label"),
                updateLocale: true
            });
        }
    }


    componentDidUpdate(){
        if(this.checkIsReadyToComplete()){
            this.setComplete();
        }

        if (this.state.hideFeedback) {
            this.hide();
        }

        if(this.state.updateLocale){
            this.handleOptionFeedback();
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.feedbackInterval);
    }

    setFeedbackInterval() {
        let interval = setInterval(this.checkShowProgressButton, 500);
        this.setState({feedbackInterval: interval});
    }

    checkShowProgressButton() {
        if (this.showProgressButton()) {
            this.props.onEnableProgression(this.state.locale.progression_label);
            clearInterval(this.state.feedbackInterval);
        }
    }

    storeUserResponse() {
        //console.log(`storeUserResponse`);
        let selectedOptions = [];
        for (let i = 0; i < this.props.responseData.checkedOptions.length; i++) {
            let selectedOption = this.props.responseData.checkedOptions[i];
            selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
        }

        let responseObj = {
            asset_id: this.props.asset_id,
            selectedOptions: selectedOptions,
            kpis: !appHelper.isDefined(this.props.responseData.outcome.kpis) || this.props.responseData.outcome.kpis !== null ? this.props.responseData.outcome.kpis : []
        };


        //console.log(responseObj);
        //console.log(this.props.callbacks);
        this.props.callbacks.storeUserResponse(responseObj);
    }

    getLocale() {
        this.setState({locale: Object.assign({}, appHelper.getLocalData(this.props.responseData.outcome))});

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {
        if (appHelper.isDefined(this.props.responseData.outcome.assets)) {
            let imageAsset = appHelper.getImageAsset(this.props.responseData.outcome.assets);
            //imageAsset = appHelper.isDefined(imageAsset.locale) ? appHelper.getLocalData(imageAsset) : imageAsset;

            if (appHelper.isDefined(imageAsset) && imageAsset.src.length > 0) {
                this.setState({imageAsset: imageAsset});
            }
        }

        if(appHelper.isDefined(this.props.responseData.outcome.audio)) {
            let audio = appHelper.getAudioAsset(this.props.responseData.outcome.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`
            };

            this.props.actions.setAudio(audioObj);
        }
    }

    onFeedbackRevealed() {
        this.storeUserResponse();
        this.scrollToTop();
    }

    scrollToTop() {
        let feedback = document.getElementById(`feedback_wrapper_${this.props.asset_id}`);
        this.props.callbacks.scrollToFeedback(feedback.offsetTop);

    }

    enableProgression() {
        this.setState({enableProgression: true});
    }

    getLinkClass() {
        return this.state.enableProgression ? "" : "disabled-link";
    }

    getDisabledState() {
        return !this.state.enableProgression;
    }

    handleOptionFeedback() {
        this.setState({updateLocale: false});
        let optionFeeback = [];
        let resources = [];

        //set parent array with feedback
        for (let i = 0; i < this.state.options.length; i++) {
            let option = this.state.options[i];
            let locale = appHelper.getLocalData(option);
            let feedback = "";

            if (appHelper.isDefined(locale.feedback) && locale.feedback.length > 0 && locale.feedback !== "<p><br></p>") {
                feedback = locale.feedback;
            }else if(appHelper.isDefined(option.feedback_id)){
                let feedbackOption = appHelper.getArrayObjectByKey(this.state.options,"option_id",option.feedback_id);
                let feedbackOptionLocale = appHelper.getLocalData(feedbackOption);
                feedback = feedbackOptionLocale.feedback;
            }
            let feedbackObj = {
                option_id: option.option_id,
                feedback: feedback,
                options: [],
                checked: false
            };

            optionFeeback = dataHelper.immutablePush(optionFeeback, feedbackObj);
        }

        for (let o = 0; o < this.state.options.length; o++) {
            let option = this.state.options[o];
            let locale = appHelper.getLocalData(option);
            let optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.checkedOptions, "option_id", option.option_id);
            let optionObject = {
                result: option.result,
                className: optionCheckedIndex > -1 ? 'checked' : 'unchecked',
                option_text: locale.option,
                option_id: option.option_id,
                kpis: appHelper.isDefined(option.kpis) && option.kpis !== null ? option.kpis : []
            };

            //if (optionCheckedIndex > -1 || this.props.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
            if (optionCheckedIndex > -1 ) {
                if (!appHelper.isDefined(option.feedback_id)) {
                    let optionFeedbackObj = appHelper.getArrayObjectByKey(optionFeeback, "option_id", option.option_id);
                    let optionFeedbackObjIndex = appHelper.getArrayObjectIndexByKey(optionFeeback, "option_id", option.option_id);

                    optionFeedbackObj = Object.assign({}, optionFeedbackObj,
                        {
                            options: dataHelper.immutablePush(optionFeedbackObj.options, optionObject),
                            checked:  !optionFeedbackObj.checked && optionCheckedIndex > -1
                        }
                    );
                    optionFeeback = dataHelper.immutableSplice(optionFeeback, optionFeedbackObjIndex, 1, optionFeedbackObj);
                } else {
                    let optionFeedbackObj = appHelper.getArrayObjectByKey(optionFeeback, "option_id", option.feedback_id);
                    let optionFeedbackObjIndex = appHelper.getArrayObjectIndexByKey(optionFeeback, "option_id", option.feedback_id);

                    optionFeedbackObj = Object.assign({}, optionFeedbackObj,
                        {
                            options: dataHelper.immutablePush(optionFeedbackObj.options, optionObject),
                            checked:  !optionFeedbackObj.checked && optionCheckedIndex > -1
                        }
                    );
                    optionFeeback = dataHelper.immutableSplice(optionFeeback, optionFeedbackObjIndex, 1, optionFeedbackObj);
                }

                let resourceLinks = appHelper.setResourceLinks(option);
                _.forEach(resourceLinks, function (resource) {
                    resources = dataHelper.immutablePush(resources,resource);
                });
            }
        }

        if (optionFeeback.length > 1) {

            optionFeeback.sort(function (a, b) {
                if (a.checked > b.checked) return -1;
                if (a.checked < b.checked) return 1;
                return 0;
            });
        }

        this.setState({optionFeedback: Object.assign([], optionFeeback)});

        this.setResources(resources);
    }

    getMissedOptions(){
        let missedOptions = [];
        for (let o = 0; o < this.state.options.length; o++) {
            let option = this.state.options[o];
            let locale = appHelper.getLocalData(option);
            let optionCheckedIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.checkedOptions, "option_id", option.option_id);
            let optionObject = {
                result: option.result,
                className: optionCheckedIndex > -1 ? 'checked' : 'unchecked',
                option_text: locale.option,
                option_id: option.option_id
            };
            if (optionCheckedIndex === -1 && this.props.responseData.outcome.result !== objectConstants.RESULT_BEST && option.result === objectConstants.RESULT_BEST && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE) {
                missedOptions = dataHelper.immutablePush(missedOptions, optionObject);
            }
        }
        if(missedOptions.length > 0){
            this.setState({missedOptions:Object.assign({},this.state.missedOptions,{
                show: true,
                options: Object.assign([],missedOptions)
            })});
        }
    }

    onFeedbackHidden() {
        this.setState(
            {
                //showResponse: false,
                showFeedbackContent: false,
                showKpis: false,
                showProgression: false
            }
        );
        //this.props.callbacks.resizeWatcher();
        if (typeof this.props.onComplete !== 'undefined') {
            this.props.onComplete();
        }
    }


    onProgressionClicked() {
        this.hide();
    }

    show() {

        let feedbackPanel = this.refs[`${this.props.asset_id}_feedbackPanel`];
        TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});
        TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
            height: 0,
            opacity: 0,
            ease: Linear.easeIn
        }).eventCallback("onComplete", this.onFeedbackRevealed);
    }

    hide() {
        this.setState({hideFeedback: false});
        let feedbackPanel = this.refs[`${this.props.asset_id}_feedbackPanel`];

        TweenLite.to(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut,
        }).eventCallback("onComplete", this.onFeedbackHidden);
    }

    onToolboxComplete() {
        this.setState({toolboxIsComplete: true});
    }

    setToolboxCallbacks() {
        this.setState(
            {
                toolboxCallbacks: Object.assign({}, this.state.toolboxCallbacks,
                    {
                        onObjectComplete: this.onToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onKeyMessageToolboxComplete() {
        this.setState({
            completeKeyMessageToolboxes: this.state.completeKeyMessageToolboxes + 1,
            checkKeyMessageToolboxesCount: true
        });
        //console.log(`onKeyMessageToolboxComplete ${this.state.keyMessagesToolbox.length}`);
        //this.setState({keyMessageToolboxIsComplete: true});
    }

    checkAllKeyMessageToolboxesComplete() {

        this.setState({
            checkKeyMessageToolboxesCount: false,
            keyMessageToolboxIsComplete: this.state.completeKeyMessageToolboxes >= this.state.keyMessagesToolbox.length
        });
    }

    setKeyMessageToolboxCallbacks() {
        this.setState(
            {
                keyMessageToolboxCallbacks: Object.assign({}, this.state.keyMessageToolboxCallbacks,
                    {
                        onObjectComplete: this.onKeyMessageToolboxComplete,
                        isReviewMode: function () {
                            return false;
                        }
                    }
                )
            }
        );
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }

    dialogsOnComplete(){
        this.setState({dialogComplete: true});
    }

    setResources(resources){
        let outcomeLinks = appHelper.setResourceLinks(this.props.responseData.outcome);
        let resourceLinks =  [...resources, ...outcomeLinks];
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
        this.setState({
            resourceLinks: Object.assign([],resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });
    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    checkIsReadyToComplete(){
        return !this.props.callbacks.hasNextObject(this.props.index)
            && this.props.responseData.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN
            && this.state.enableProgression
            && !this.state.completionCalled
            //&& ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;
    }

    setComplete(){
        this.setState({completionCalled: true});
        this.props.onComplete();
    }

    showProgressButton(){
        /*return (
            (!this.props.callbacks.hasNextObject(this.props.screenObject) && this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_TRY_AGAIN) || this.props.callbacks.hasNextObject(this.props.screenObject))
            && appHelper.isDefined(this.state.locale.progression_label)
            && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;*/

        return this.state.enableProgression
            && appHelper.isDefined(this.state.locale.progression_label)
           // && ((this.state.hasBadges && this.state.badgesCollected) || !this.state.hasBadges )
            && this.state.resourcesAreComplete;
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            if (this.state.enableProgression) {
                this.onReview();
            }
        }
    }

    onReview() {
		this.props.onShowReview(`review_link_${this.props.asset_id}`);

    }


    render() {
        return (
            <div className={`feedback-panel ${this.props.responseData.outcome.result}`}
                 ref={`${this.props.asset_id}_feedbackPanel`}>
                <img src={require(`../../../../assets/images/svg/${this.props.responseData.outcome.result}.svg`)} style={kpiConstants.WATERMARK_STYLES} alt=""/>
                <div className="feedback-content-col">
                    {this.state.showKpis
                        ? <ScoreKpi bite_id={this.props.responseData.bite_id}
                                        displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                        showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                        showTitle={this.state.kpiDashboardParams.showTitle}
                                        onUpdateComplete={this.enableProgression}/>
                        : null
                    }



                    {appHelper.isDefined(this.state.locale.feedback)  && this.state.dialogComplete  && this.state.locale.feedback !== "<p><br></p>" && this.props.responseData.outcome.enable_feedback
                        ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                        : null
                    }

                    {this.state.optionFeedback.length > 0  && this.state.dialogComplete && this.props.responseData.outcome.enable_feedback
                        ? <OptionFeeback feedback_options={this.state.optionFeedback}
                                         asset_id={this.props.asset_id}
                                         responseData={this.props.responseData}
                                         missedOptions={this.state.missedOptions}/>
                        : null
                    }

                    {
                        this.state.hasResources
                            ?
                            <Resources resources={this.state.resourceLinks}
                                       onResourcesComplete={this.onResourcesComplete}/>
                            :
                            null
                    }

                    {this.props.responseData.outcome.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE  && this.state.dialogComplete &&  this.state.resourcesAreComplete  && this.props.contentData.experience.include_explore_feedback
                        ? <div className={`guroo-active-link text-center ${this.getLinkClass()}`} role="link" tabIndex="0"
                               id={`review_link_${this.props.asset_id}`}
                               onKeyDown={this.setKeyboardAccessibility}
                               onClick={this.onReview}>{this.state.review_other_options_label}</div>
                        : null
                    }
                </div>
            </div>
        );
    }
}

/*
*  {this.state.keyMessages.length > 0
                        ? <KeyMessages key_messages={this.state.keyMessages}
                                       asset_id={this.props.asset_id}
                                       toolboxCallbacks={this.state.keyMessageToolboxCallbacks}
                                       onComplete={this.showProgressionButton}/>
                        : null
                    }*/
MultipleAnswerFeedback.propTypes = {
    screenObject: PropTypes.object,
    options: PropTypes.array.isRequired,
    key_messages: PropTypes.array,
    responseData: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    index: PropTypes.number,
    onShowReview: PropTypes.func,
    onComplete: PropTypes.func,
    onEnableProgression: PropTypes.func,
    hideFeedback: PropTypes.bool,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

MultipleAnswerFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswerFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswerFeedback.js
 **/